import { render, staticRenderFns } from "./comparePrice.vue?vue&type=template&id=0388e9c0&scoped=true&"
import script from "./comparePrice.vue?vue&type=script&lang=js&"
export * from "./comparePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388e9c0",
  null
  
)

export default component.exports